import { render, staticRenderFns } from "./FilterTreeModal.vue?vue&type=template&id=615a20d8&scoped=true&"
import script from "./FilterTreeModal.vue?vue&type=script&lang=js&"
export * from "./FilterTreeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a20d8",
  null
  
)

export default component.exports